import { Row, Col, Form } from "react-bootstrap";
import PropTypes from "prop-types";

const PromotionTypeFields = ({
    promotionType,
    PromotionType,
    // Discount props
    discountType,
    setDiscountType,
    discountValue,
    setDiscountValue,
    DiscountType,
    DiscountTypeLabels,
    // BOGO props
    bogoAppliesTo,
    setBogoAppliesTo,
    BogoAppliesTo,
    BogoAppliesToLabels,
    buyQuantity,
    setBuyQuantity,
    getQuantity,
    setGetQuantity,
    bogoOfferType,
    setBogoOfferType,
    bogoDiscountValue,
    setBogoDiscountValue,
    BogoOfferType,
    BogoOfferTypeLabels,
    // Coupon props
    couponCode,
    setCouponCode,
    minOrderAmount,
    setMinOrderAmount,
    maxDiscountAmount,
    setMaxDiscountAmount,
    timesUsable,
    setTimesUsable,
    couponDescription,
    setCouponDescription
}) => {
    return (
        <>
            {/* Discount-specific fields */}
            {promotionType === PromotionType.DISCOUNT && (
                <Row className='mb-3'>
                    <Col sm={6}>
                        <Form.Group className='form-group'>
                            <Form.Label>Discount Type *</Form.Label>
                            <Form.Select
                                value={discountType}
                                onChange={(e) => setDiscountType(e.target.value)}
                                required
                            >
                                <option value={DiscountType.PERCENTAGE}>{DiscountTypeLabels[DiscountType.PERCENTAGE]}</option>
                                <option value={DiscountType.FLAT}>{DiscountTypeLabels[DiscountType.FLAT]}</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col sm={6}>
                        <Form.Group className='form-group'>
                            <Form.Label>Discount Value * {discountType === DiscountType.PERCENTAGE ? '(%)' : '($)'}</Form.Label>
                            <Form.Control
                                type='number'
                                step='0.01'
                                value={discountValue}
                                onChange={(e) => setDiscountValue(e.target.value)}
                                placeholder={`Enter ${discountType === DiscountType.PERCENTAGE ? 'percentage' : 'flat amount'}`}
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
            )}

            {/* BOGO-specific fields */}
            {promotionType === PromotionType.BOGO && (
                <>
                    <Row className='mb-3'>
                        <Col sm={4}>
                            <Form.Group className='form-group'>
                                <Form.Label>Applies To *</Form.Label>
                                <Form.Select
                                    value={bogoAppliesTo || BogoAppliesTo.PRODUCT}
                                    onChange={(e) =>
                                        setBogoAppliesTo(
                                            e.target.value === BogoAppliesTo.ITEM
                                                ? BogoAppliesTo.ITEM
                                                : BogoAppliesTo.PRODUCT
                                        )
                                    }
                                    required
                                >
                                    <option value={''}>Choose <sup>*</sup></option>
                                    <option value={BogoAppliesTo.PRODUCT}>{BogoAppliesToLabels[BogoAppliesTo.PRODUCT]}</option>
                                    <option value={BogoAppliesTo.ITEM}>{BogoAppliesToLabels[BogoAppliesTo.ITEM]}</option>
                                </Form.Select>
                                <Form.Text className="text-muted">
                                    Controls whether this BOGO is evaluated at the product level or per line item
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        <Col sm={4}>
                            <Form.Group className='form-group'>
                                <Form.Label>Buy Quantity *</Form.Label>
                                <Form.Control
                                    type='number'
                                    step='1'
                                    min='1'
                                    value={buyQuantity}
                                    onChange={(e) => setBuyQuantity(e.target.value)}
                                    placeholder='Enter buy quantity'
                                    required
                                />
                                <Form.Text className="text-muted">
                                    Number of items customer must buy
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        <Col sm={4}>
                            <Form.Group className='form-group'>
                                <Form.Label>Get Quantity *</Form.Label>
                                <Form.Control
                                    type='number'
                                    step='1'
                                    min='1'
                                    value={getQuantity}
                                    onChange={(e) => setGetQuantity(e.target.value)}
                                    placeholder='Enter get quantity'
                                    required
                                />
                                <Form.Text className="text-muted">
                                    Number of items customer gets
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        <Col sm={4}>
                            <Form.Group className='form-group'>
                                <Form.Label>Offer Type *</Form.Label>
                                <Form.Select
                                    value={bogoOfferType}
                                    onChange={(e) => setBogoOfferType(e.target.value)}
                                    required
                                >
                                    <option value={BogoOfferType.FREE}>{BogoOfferTypeLabels[BogoOfferType.FREE]}</option>
                                    <option value={BogoOfferType.PERCENTAGE_OFF}>{BogoOfferTypeLabels[BogoOfferType.PERCENTAGE_OFF]}</option>
                                    <option value={BogoOfferType.FLAT_OFF}>{BogoOfferTypeLabels[BogoOfferType.FLAT_OFF]}</option>
                                </Form.Select>
                                <Form.Text className="text-muted">
                                    Type of discount on get items
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        {(bogoOfferType === BogoOfferType.PERCENTAGE_OFF || bogoOfferType === BogoOfferType.FLAT_OFF) && (
                            <><Col sm={4}>
                                <Form.Group className='form-group'>
                                    <Form.Label>
                                        Discount Value * {bogoOfferType === BogoOfferType.PERCENTAGE_OFF ? '(%)' : '($)'}
                                    </Form.Label>
                                    <Form.Control
                                        type='number'
                                        step='0.01'
                                        min='0.01'
                                        max={bogoOfferType === BogoOfferType.PERCENTAGE_OFF ? '100' : undefined}
                                        value={bogoDiscountValue}
                                        onChange={(e) => setBogoDiscountValue(e.target.value)}
                                        placeholder={`Enter ${bogoOfferType === BogoOfferType.PERCENTAGE_OFF ? 'percentage' : 'dollar amount'}`}
                                        required
                                    />
                                    <Form.Text className="text-muted">
                                        {bogoOfferType === BogoOfferType.PERCENTAGE_OFF
                                            ? 'Percentage off on get items (e.g., 50 for 50% off)'
                                            : 'Dollar amount off on get items'}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                                <Col sm={4}>
                                    <div
                                        className="mt-4"
                                        style={{
                                            backgroundColor: '#f8f9fa',
                                            border: '1px solid #dee2e6',
                                            borderRadius: '8px',
                                            padding: '12px 16px',
                                            fontSize: '14px',
                                            color: '#495057'
                                        }}
                                    >
                                        <strong style={{ color: '#212529' }}>Example:</strong> Buy {buyQuantity || 'X'}, Get {getQuantity || 'Y'} at{' '}
                                        <span style={{
                                            color: '#28a745',
                                            fontWeight: '600'
                                        }}>
                                            {bogoOfferType === BogoOfferType.PERCENTAGE_OFF
                                                ? `${bogoDiscountValue || 'Z'}% off`
                                                : `$${bogoDiscountValue || 'Z'} off`}
                                        </span>
                                    </div>
                                </Col>
                            </>
                        )}
                    </Row>
                    {/* Show discount value field for PERCENTAGE_OFF and FLAT_OFF */}

                </>
            )}

            {/* Coupon-specific fields */}
            {promotionType === PromotionType.COUPON && (
                <>
                    <Row className='mb-3'>
                        <Col sm={6}>
                            <Form.Group className='form-group'>
                                <Form.Label>Coupon Code *</Form.Label>
                                <Form.Control
                                    type='text'
                                    value={couponCode}
                                    onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                                    placeholder='Enter coupon code'
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group className='form-group'>
                                <Form.Label>Times Usable *</Form.Label>
                                <Form.Control
                                    type='number'
                                    step='1'
                                    min='1'
                                    value={timesUsable}
                                    onChange={(e) => setTimesUsable(e.target.value)}
                                    placeholder='Number of times coupon can be used'
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col sm={6}>
                            <Form.Group className='form-group'>
                                <Form.Label>Minimum Order Amount ($)</Form.Label>
                                <Form.Control
                                    type='number'
                                    step='0.01'
                                    min='0'
                                    value={minOrderAmount}
                                    onChange={(e) => setMinOrderAmount(e.target.value)}
                                    placeholder='Optional minimum order amount'
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group className='form-group'>
                                <Form.Label>Maximum Discount Amount ($)</Form.Label>
                                <Form.Control
                                    type='number'
                                    step='0.01'
                                    min='0'
                                    value={maxDiscountAmount}
                                    onChange={(e) => setMaxDiscountAmount(e.target.value)}
                                    placeholder='Optional maximum discount cap'
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col sm={12}>
                            <Form.Group className='form-group'>
                                <Form.Label>Coupon Description</Form.Label>
                                <Form.Control
                                    as='textarea'
                                    rows={2}
                                    value={couponDescription}
                                    onChange={(e) => setCouponDescription(e.target.value)}
                                    placeholder='Enter coupon description'
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

export default PromotionTypeFields;

PromotionTypeFields.propTypes = {
    promotionType: PropTypes.string,
    PromotionType: PropTypes.shape({
        DISCOUNT: PropTypes.string.isRequired,
        BOGO: PropTypes.string.isRequired,
        COUPON: PropTypes.string.isRequired,
    }).isRequired,

    // Discount props
    discountType: PropTypes.string,
    setDiscountType: PropTypes.func,
    discountValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setDiscountValue: PropTypes.func,
    DiscountType: PropTypes.shape({
        PERCENTAGE: PropTypes.string.isRequired,
        FLAT: PropTypes.string.isRequired,
    }),
    DiscountTypeLabels: PropTypes.object,

    // BOGO props
    bogoAppliesTo: PropTypes.string,
    setBogoAppliesTo: PropTypes.func,
    BogoAppliesTo: PropTypes.shape({
        PRODUCT: PropTypes.string.isRequired,
        ITEM: PropTypes.string.isRequired,
    }),
    BogoAppliesToLabels: PropTypes.object,
    buyQuantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setBuyQuantity: PropTypes.func,
    getQuantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setGetQuantity: PropTypes.func,
    bogoOfferType: PropTypes.string,
    setBogoOfferType: PropTypes.func,
    bogoDiscountValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setBogoDiscountValue: PropTypes.func,
    BogoOfferType: PropTypes.shape({
        FREE: PropTypes.string.isRequired,
        PERCENTAGE_OFF: PropTypes.string.isRequired,
        FLAT_OFF: PropTypes.string.isRequired,
    }),
    BogoOfferTypeLabels: PropTypes.object,

    // Coupon props
    couponCode: PropTypes.string,
    setCouponCode: PropTypes.func,
    minOrderAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setMinOrderAmount: PropTypes.func,
    maxDiscountAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setMaxDiscountAmount: PropTypes.func,
    timesUsable: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setTimesUsable: PropTypes.func,
    couponDescription: PropTypes.string,
    setCouponDescription: PropTypes.func,
};
